export default __webpack_public_path__ + "static/media/rnr-sports-table-24-cn.580c508a.webp";